'use client';

import FeatureWorkContent from './FeatureWorkContent';

function FeatureWorkMainContent({ workContentData, t }) {
  return (
    <section className="px-5 transition-all duration-700 md:px-0">
      <div className="mx-auto max-w-[1280px]">
        {workContentData.map((data) => (
          <FeatureWorkContent
            key={data.id}
            query={data.query}
            image={data.image}
            title={t[data.title]}
            items={data.items}
            description={t[data?.description]}
            subTitle={t[data.subTitle]}
            subImage={data.image}
            t={t}
          />
        ))}
      </div>
    </section>
  );
}

export default FeatureWorkMainContent;
